import Logo from "../components/Logo";
import AnfrageForm from "../components/AnfrageForm";

export default function Formular() {
  return (
    <section id="anfrage" className="navy-depth scroll-mt-4 py-20 sm:py-28 lg:py-32">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <div className="flex flex-col items-center text-center">
          <Logo invertiert />
          <h2 className="mt-9 text-2xl font-medium tracking-[-0.01em] text-white sm:text-3xl lg:text-4xl" data-testid="formular-ueberschrift">
            Zielgruppen-Analyse anfragen
          </h2>
          <p className="mt-5 max-w-2xl text-base leading-[1.85] text-hellblau" data-testid="formular-einleitung">
            Fünf kurze Fragen, damit die 45 Minuten für Sie wertvoll sind. Das dauert etwa eine Minute. Passt es,
            wählen Sie direkt im Anschluss Ihren Termin.
          </p>
        </div>
        <div className="mx-auto mt-12 max-w-2xl">
          <AnfrageForm />
        </div>
      </div>
    </section>
  );
}
